import View from 'mixins/view';
import moment from 'moment/moment';
import { pluralVariety } from '@utils/translations';

const elements = {
  container: '.notification__text',
};

export default class UserNotificationView extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(`<li class="notifications-list__item"></li>`));
  }
  buildImage(img) {
    return $(`
      <figure class="notification__media rmpl-flex-container rmpl-flex-justified">
          <img src="${img}" alt="" />
      </figure>
    `);
  }
  render() {
    moment.locale('pl');
    const model = this.model;
    const createdAt = model.get('createdAt');
    const momentCreatedAt = moment(createdAt);

    if (model.get('type') === 'ad') {
        this.rootEl.html(`
            <a href="${model.get('url')}" target='_blank'>
                <div class="rmpl-flex-container rmpl-flex-aligned notification__text">
                    <div class="nt-meta">
                      <!--  <time class="nt-meta-time" datetime="${createdAt}">${momentCreatedAt.fromNow()}</time> -->
                    </div>
                    <div class="nt-header">${model.get('text')}</div>
                </div>
            </a>
        `);

        const img = model.get('photo') ? model.get('photo') : '/img/news-placeholder.png';
        this.rootEl.find('a').prepend(this.buildImage(img));
        return;
    }

    let content = `<span> ${model.get('username')} </span>`;
    if (model.get('type') === 'mention') {
      content += ` oznaczył Cię w komentarzu.`;
    } else {
      const replies = model.get('replyCount');
      if (replies === 1) {
        content += ` odpowiedział na komentarz.`;
      } else {
        const restReplies = replies - 1;
        const others = restReplies > 1 ? pluralVariety(restReplies, 'inna', 'inne', 'innych') : '';
        const responses = pluralVariety(restReplies, 'osoba odpowiedziała', 'osoby odpowiedziały', 'osób odpowiedziało');
        content += ` i ${restReplies} ${others} ${responses} na komentarz.`;
      }
    }

    this.rootEl.html(`
        <a href="${model.get('url')}">
            <div class="rmpl-flex-container rmpl-flex-aligned notification__text">
                <div class="nt-meta">
                    <time class="nt-meta-time" datetime="${createdAt}">${momentCreatedAt.fromNow()}</time>
                </div>
                <div class="nt-header">${content}</div>
            </div>
        </a>
    `);

    const img = model.get('photo') ? model.get('photo') : '/img/news-placeholder.png';
    this.rootEl.find('a').prepend(this.buildImage(img));
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/mixins/user-notification-view.js